import { isNonNil } from './fn';

export const isServerSide = typeof window === 'undefined';

export const isClientSide = !isServerSide;

export const getClientSideUserAgent = () => {
  return isClientSide ? navigator.userAgent : '';
};

export const isAndroid = (userAgent: string) => {
  return isNonNil(userAgent.match(/Android/i));
};

export const isIOSMobile = (userAgent: string) => {
  return isNonNil(userAgent.match(/iPhone/i));
};

export const isAppWebView = (userAgent: string) => {
  /* vuddy/AOS|iOS/(appVersion)/(languageCode) */
  return /vuddy\/(aos|ios)/i.test(userAgent);
};

export const isMobile = (userAgent: string) => {
  return (
    isAndroid(userAgent) || isIOSMobile(userAgent) || isAppWebView(userAgent)
  );
};

export const getOSName = () => {
  const useragent = getClientSideUserAgent();
  if (useragent.match(/Win/i)) {
    return 'windows';
  } else if (useragent.match(/Mac/i)) {
    return 'mac';
  } else if (useragent.match(/Linux/i)) {
    return 'linux';
  } else if (useragent.match(/Android/i)) {
    return 'android';
  } else if (useragent.match(/iOS/i)) {
    return 'iOS';
  } else {
    return 'unknown';
  }
};

export const getAndroidOSVersion = (userAgent: string) => {
  const match = userAgent.toLowerCase().match(/android\s([0-9.]*)/);
  return isNonNil(match) ? match[1] : undefined;
};

export const isSafariBrowser = (userAgent: string) => {
  return /^((?!chrome|android).)*safari/i.test(userAgent);
};

export const isInAppBrowser = (userAgent: string) => {
  if (isServerSide || !isMobile(userAgent)) {
    return false;
  }

  const inAppBrowserRegex =
    /inapp|Instagram|FB_IAB|FB4A|FBAN|FBIOS|KAKAOTALK|kakaotalk\/[^1]/i;
  return inAppBrowserRegex.test(getClientSideUserAgent());
};

export const getAppVersion = (userAgent: string) => {
  // vuddy/AOS/25.09.10/ko 또는 vuddy/iOS/25.09.10/ko 패턴에서 버전 추출
  const match = userAgent.match(/vuddy\/(aos|ios)\/([^/]+)/i);
  return match ? match[2] : undefined;
};
